import React from 'react';

// A-ADS (Anonymous Ads) crypto-friendly banner, ad unit 2449843.
// Rendered at the very bottom of the app shell, under the mansion home button
// (the shell is a flex column: content order 0, mansion header order 2, this
// order 3). The stock A-ADS snippet ships with z-index 99998, which would
// bleed through the Dashboard/Auth/Payment overlays (z-index 9999-10011), so
// it is lowered here; everything else matches the snippet.
const AAdsBanner = () => (
  <div
    id="frame"
    style={{
      width: '100%',
      margin: 'auto',
      position: 'relative',
      zIndex: 10,
      order: 3,
    }}
  >
    <iframe
      title="A-ADS advertisement"
      data-aa="2449843"
      src="//acceptable.a-ads.com/2449843/?size=Adaptive"
      style={{
        border: 0,
        padding: 0,
        width: '100%',
        // Comfortable banner width on desktop (matches the homepage ads)
        // while staying full-width on phones.
        maxWidth: '970px',
        height: '150px',
        overflow: 'hidden',
        display: 'block',
        margin: 'auto',
      }}
    ></iframe>
  </div>
);

export default AAdsBanner;
